<!--销售退货扫码入仓--->
<template>
    <div class="business-content-main" v-loading="loading">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">标签</div>
                <el-input
                    ref="inputdata"
                    v-model="scanData"
                    clearable
                    :placeholder="phholder"
                    size="small"
                    style="width: 250px"
                    @blur="inputblur()"
                    @change="inputDataChange()"
                    class="search-name"
                ></el-input>
                <el-button size="small" class="search-btn btn-primary" :disabled="isForbidBatch && !isEnoughSubmit" @click="submit()">提交入仓</el-button>
                <div v-if="orderCode" class="search-name">销售退货单号：{{ orderCode }}</div>
                <div class="search-name" style="color: red">（确保焦点在标签输入框内，并检查电脑的输入法是否英文输入）</div>
            </div>
        </div>
        <div>
            <el-row :gutter="20" class="table-ctn">
                <el-col :span="12">
                    <div class="grid-content">
                        <el-table :header-cell-style="{ background: '#F2F6FC' }" border="" :data="dataList" style="width: 100%">
                            <el-table-column label="汽配编码" show-overflow-tooltip min-width="100px" prop="APCode"></el-table-column>
                            <el-table-column label="汽配名称" show-overflow-tooltip min-width="100px" prop="GoodName"></el-table-column>
                            <el-table-column label="适用车型" show-overflow-tooltip min-width="100px" prop="AutoSerise"></el-table-column>
                            <el-table-column label="退货数量" show-overflow-tooltip width="80px" prop="Count"></el-table-column>
                            <el-table-column label="已入仓数" show-overflow-tooltip width="80px" prop="WarehousedCount"></el-table-column>
                            <el-table-column label="待入数量" show-overflow-tooltip width="80px">
                                <template slot-scope="scope">
                                    <div
                                        :class="{
                                            'check-class': scope.row.Count - scope.row.WarehousedCount > 0
                                        }"
                                    >
                                        {{ scope.row.Count - scope.row.WarehousedCount }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="扫码数量" show-overflow-tooltip width="80px">
                                <template slot-scope="scope">
                                    <div
                                        :class="{
                                            'check-class-enough': scope.row.Count - scope.row.WarehousedCount - scope.row.ScanCount == 0 && scope.row.ScanCount > 0
                                        }"
                                    >
                                        {{ scope.row.ScanCount }}
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="grid-content">
                        <div class="labelzone" v-infinite-scroll="bottomLoadHandle">
                            <template v-for="(item, index) in cardList">
                                <el-card class="box-card" :key="index" v-if="index < showLine">
                                    <div style="padding: 14px">
                                        <span class="goodname">{{ item.GoodName }}</span>
                                        <div class="bottom clearfix">
                                            <span class="apcode">{{ item.APCode }}</span>
                                            <span class="button">
                                                {{ item.PackingSpec + ' ' + item.Unit }}
                                            </span>
                                        </div>
                                        <div class="bottom clearfix">
                                            <time class="time">{{ item.LabelCode }}</time>
                                            <el-button type="text" class="button" icon="el-icon-delete" style="color: red" @click="delItem(item)"></el-button>
                                        </div>
                                    </div>
                                </el-card>
                            </template>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <audio ref="audio" controls hidden></audio>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
export default {
    name: 'SROrderScan',
    components: {
        breadcrumb
    },
    data() {
        return {
            phholder: '',
            orderId: '',
            loading: false,
            oid: '',
            dataList: [],
            scanData: '',
            labels: [],
            cardList: [],
            orderCode: '',
            isAutoSubmit: false,
            isForbidBatch: false,
            isEnoughSubmit: false,
            firstScanOrder: true,
            currectAudio: '/download/currect.mp3',
            errorAudio: '/download/error.mp3',
            allOutAudio: '/download/allout.mp3',
            wrongXSAudio: '/download/wrongxs.mp3',
            repetLabel: '/download/repetlabel.mp3',
            enoughAudio: '/download/enough.mp3',
            autoSubmitAudio: '/download/autosubmit.mp3',
            showLine: 25,
            recordPickerAudio: '/download/lrjhy.mp3',
            changePickerAudio: '/download/ggjhy.mp3',
            checkPickerAudio: '/download/checkpicker.mp3',
            submitSuccessAudio: '/download/submitsuccess.mp3'
        };
    },
    created() {
        this.getConfigByCodes();
    },
    mounted() {
        let that = this;
        that.oid = that.$route.query.oid;
        if (that.oid) {
            that.phholder = '请扫描标签条码';
            that.firstScanOrder = false;
            that.getOrderDetail(0);
        } else {
            that.phholder = '请扫描销售退货单的二维码或条码';
        }
    },
    methods: {
        getConfigByCodes() {
            let codes = ['smzdtj', 'xzxsshjkqbcc'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'smzdtj':
                                this.isAutoSubmit = result;
                                break;
                            case 'xzxsshjkqbcc': //限制分批出仓
                                this.isForbidBatch = result;
                                break;
                        }
                    }
                }
            });
        },
        getOrderDetail(type) {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpSaleReturnOrder/GetSROrderByScanData',
                    data: {
                        Order: that.oid,
                        Type: type
                    }
                })
                .then(res => {
                    let data = res.data;
                    that.orderCode = data.OrderCode;
                    that.oid = data.OrderId;
                    let DetailList = data.DetailList;
                    this.dataList = [];
                    for (let i = 0; i < DetailList.length; i++) {
                        that.dataList.push({
                            OrderRsId: DetailList[i].OrderRsId,
                            GoodsId: DetailList[i].GoodsId,
                            APCode: DetailList[i].APCode,
                            GoodName: DetailList[i].GoodName,
                            Unit: DetailList[i].Unit,
                            AutoSerise: DetailList[i].AutoSerise,
                            Count: DetailList[i].Count,
                            WarehousedCount: DetailList[i].WarehousedCount,
                            ScanCount: 0,
                            SortField: 0
                        });
                    }
                })
                .catch(() => {
                    that.firstScanOrder = true;
                });
        },
        // 失去焦点
        inputblur() {
            let that = this;
            // FireFox 和 IE 失去焦点，blur直接执行focus 不会生效，加个延时
            setTimeout(() => {
                if (that.$refs.inputdata) that.$refs.inputdata.focus();
            }, 100);
        },
        inputDataChange() {
            let that = this;
            if (that.scanData.indexOf('AP-') > -1) {
                if (that.scanData.length == 20) {
                    that.$util
                        .axiosGet({
                            url: '/api/EntpSaleReturnOrder/CheckEntpSROrderGoods',
                            data: {
                                SROrderId: that.oid,
                                LabelCode: that.scanData
                            }
                        })
                        .then(res => {
                            let data = res.data;
                            if (data) {
                                let datalist = that.dataList;
                                if (!(datalist && datalist.length > 0)) {
                                    that.$util.warningMsg('商品明细异常！');
                                    that.aplayAudio(that.errorAudio);
                                    return;
                                }

                                let label = {
                                    APCode: data.APCode,
                                    GoodName: data.GoodName,
                                    PackingSpec: data.PackingSpec,
                                    LabelCode: data.LabelCode,
                                    Unit: data.Unit,
                                    LabelId: data.LabelId,
                                    GoodsId: data.GoodsId,
                                    OrderRsId: data.OrderRsId
                                };
                                let isRepet = false;
                                if (that.cardList.length > 0) {
                                    that.cardList.forEach(element => {
                                        if (element.LabelCode == label.LabelCode) {
                                            isRepet = true;
                                            that.$util.warningMsg('重复标签！');
                                            return;
                                        }
                                    });
                                }
                                if (isRepet) {
                                    that.aplayAudio(that.repetLabel);
                                    return;
                                }

                                that.isEnoughSubmit = true;
                                let goods = null;
                                let scount = 0;
                                let needCount = 0;
                                
                                //如果标签返回明细Id，先去订单的明细做匹配，如果匹配不上再通过商品数量匹配
                                if (label.OrderRsId) {
                                    //var big = arr.find(val => val>2);
                                    goods = datalist.find(x => x.OrderRsId == label.OrderRsId);
                                    if (goods) {
                                        scount = goods.ScanCount;
                                        needCount = goods.Count - goods.WarehousedCount;
                                        if (scount + label.PackingSpec <= needCount) {
                                            goods.ScanCount += label.PackingSpec;
                                            that.cardList.unshift(label);
                                            // that.labels.unshift(data.LabelId);
                                            that.labels.unshift({ LabelId: label.LabelId, OrderRsId: label.OrderRsId });
                                        } else {
                                            that.aplayAudio(that.enoughAudio);
                                            that.$util.warningMsg('标签的商品总数大于销售退货待入的数量！');
                                            return;
                                        }
                                        goods.SortField = goods.Count - goods.WarehousedCount - goods.ScanCount == 0 && goods.ScanCount > 0 ? 1 : 0;
                                    }
                                }

                                let errMsg = '';
                                if (!goods) {
                                    //通过商品数量匹配
                                    for (let i = 0; i < datalist.length; i++) {
                                        if (datalist[i].GoodsId == label.GoodsId) {
                                            scount = datalist[i].ScanCount;
                                            needCount = datalist[i].Count - datalist[i].WarehousedCount;
                                            if (scount + label.PackingSpec > needCount) {
                                                errMsg = '标签的商品总数大于销售退货待入的数量！';
                                                // that.aplayAudio(that.enoughAudio);
                                                // that.$util.warningMsg('标签的商品总数大于销售退货待入的数量！');
                                                // return;
                                            } else {
                                                datalist[i].ScanCount += label.PackingSpec;
                                                that.cardList.unshift(label);
                                                // that.labels.unshift(data.LabelId);
                                                that.labels.unshift({ LabelId: label.LabelId, OrderRsId: datalist[i].OrderRsId });
                                                datalist[i].SortField =
                                                    datalist[i].Count - datalist[i].WarehousedCount - datalist[i].ScanCount == 0 && datalist[i].ScanCount > 0 ? 1 : 0;
                                                goods = datalist[i];
                                                errMsg="";
                                                break;
                                            }
                                        }
                                    }
                                }

                                if (!goods) {
                                    if (errMsg) {
                                        that.aplayAudio(that.enoughAudio);
                                        that.$util.warningMsg(errMsg);
                                        return;
                                    } else {
                                        that.aplayAudio(that.errorAudio);
                                        that.$util.warningMsg('找不到标签对于的商品！');
                                        return;
                                    }
                                }
                                //若目标数组中某一个对象都符合条件则返回true，否则返回false
                                that.isEnoughSubmit = !datalist.some(x => x.Count - x.WarehousedCount != x.ScanCount);

                                datalist.sort(function(a, b) {
                                    return a.SortField - b.SortField;
                                });
                                this.dataList = datalist;

                                //判断是否已经完成了销售单的标签已经扫够，如果刚好够的话，自动提交
                                if (that.isAutoSubmit) {
                                    if (that.isEnoughSubmit) that.submit();
                                    else that.aplayAudio(that.currectAudio);
                                } else that.aplayAudio(that.currectAudio);
                            } else {
                                that.aplayAudio(that.errorAudio);
                            }
                        })
                        .catch(() => {
                            that.aplayAudio(that.errorAudio);
                        });
                } else {
                    that.aplayAudio(that.errorAudio);
                    that.$util.warningMsg('标签码长度不符合规则！请检查输入法是否为英文输入法');
                }
            } else if (that.scanData.length > 0) {
                that.oid = that.scanData;
                if (that.firstScanOrder) {
                    that.firstScanOrder = false;
                    that.getOrderDetail(1);
                } else {
                    that.$confirm('已经有未提交入仓销售退货单，是否确定放弃提交？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: false
                    })
                        .then(() => {
                            that.firstScanOrder = true;
                            that.labels = [];
                            that.cardList = [];
                            that.dataList = [];
                            that.getOrderDetail(1);
                        })
                        .catch(() => {});
                }
            } else {
                that.aplayAudio(that.errorAudio);
                that.$util.warningMsg('标签码长度不符合规则！请检查输入法是否为英文输入法');
            }
            that.scanData = '';
        },
        delItem(item) {
            let that = this;
            if (item) {
                this.cardList.splice(this.cardList.indexOf(item), 1);
                // this.labels.splice(this.labels.indexOf(item.LabelId), 1);
                this.labels.splice(this.labels.indexOf({ LabelId: item.LabelId, OrderRsId: item.OrderRsId }), 1);
                let datalist = that.dataList;
                if (datalist && datalist.length > 0) {
                    for (let i = 0; i < datalist.length; i++) {
                        if (datalist[i].OrderRsId == item.OrderRsId||datalist[i].GoodsId == item.GoodsId) {
                            if (datalist[i].ScanCount > 0) {
                                datalist[i].ScanCount -= item.PackingSpec;
                                datalist[i].SortField = datalist[i].Count - datalist[i].WarehousedCount - datalist[i].ScanCount == 0 && datalist[i].ScanCount > 0 ? 1 : 0;
                                datalist.sort(function(a, b) {
                                    return a.SortField - b.SortField;
                                });
                                this.dataList = datalist;
                                return;
                            }
                        }
                    }
                }
            }
        },
        submit() {
            let that = this;
            if (that.labels.length == 0) {
                that.$util.warningMsg('无标签信息，请重新扫码');
                return;
            }
            if (that.isAutoSubmit) {
                this.loading = true;
                this.$util
                    .axiosPost({
                        url: '/api/EntpSaleReturnOrder/EntpScanLabelInStorage',
                        data: {
                            SaleROrderId: that.oid,
                            // LabelIdList: that.labels
                            LabelList: that.labels
                        },
                        hideLoading: false
                    })
                    .then(res => {
                        that.$util.successMsg('已自动入仓成功');
                        that.aplayAudio(that.autoSubmitAudio);
                        that.labels = [];
                        that.cardList = [];
                        //跳回列表页
                        setTimeout(() => {
                            that.$router.push('/inventoryManage/salesReturns/takeIn');
                        }, 2000);
                    })
                    .catch(() => {
                        that.loading = false;
                    })
                    .finally(() => {
                        that.loading = false;
                    });
            } else {
                that.$confirm('确定提交入仓吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                }).then(() => {
                    this.loading = true;
                    this.$util
                        .axiosPost({
                            url: '/api/EntpSaleReturnOrder/EntpScanLabelInStorage',
                            data: {
                                SaleROrderId: that.oid,
                                // LabelIdList: that.labels
                                LabelList: that.labels
                            }
                        })
                        .then(res => {
                            that.$util.successMsg('入仓成功');
                            that.aplayAudio(that.submitSuccessAudio);
                            that.labels = [];
                            that.cardList = [];
                            that.firstScanOrder = true;
                            that.getOrderDetail(0);
                            that.loading = false;
                        })
                        .catch(() => {
                            that.loading = false;
                        });
                });
            }
        },
        aplayAudio(audioUrl) {
            this.$refs.audio.src = audioUrl;
            this.$nextTick(res => {
                this.$refs.audio.load();
                this.$refs.audio.play();
            });
        },
        // 触底加载
        bottomLoadHandle() {
            let listLen = this.cardList.length;
            if (listLen > this.showLine + 25) {
                this.showLine += 25;
            } else {
                this.showLine = listLen;
            }
        }
    }
};
</script>
<style lang="less" scoped>
.labelzone {
    display: flex;
    justify-content: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    padding-left: 20px;
    width: 100%;
    height: 100%;
    margin-bottom: 30px;
    overflow-y: scroll;
    height: calc(100vh - 300px);
}
.labelk {
    display: flex;
    flex-direction: column;
}
.box-card {
    width: 220px;
    margin: 5px;
}

.time {
    font-size: 13px;
    color: #999;
}

.bottom {
    margin-top: 13px;
    line-height: 12px;
}

.button {
    padding: 0;
    float: right;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: '';
}

.clearfix:after {
    clear: both;
}

.goodname {
    font-size: 18px;
    line-height: 24px;
}
.apcode {
    font-size: 15px;
}
.check-class {
    color: red;
    font-weight: bold;
}
.check-class-enough {
    color: green;
    font-weight: bold;
}
</style>
